import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { MenuItemService } from '../../core/services/menu-item.service'
import { MenuItems } from '../../core/models/menu-items'
import { ActivatedRoute, Router } from '@angular/router';
import { Constants, MENU_ITEM_LIST } from '../../core/config/Constants';
import { element } from 'protractor';
import { CustomTitlePipe } from '../../core/pipes/custom-title.pipe';
@Component({
  selector: 'app-menu-items',
  templateUrl: './menu-items.html',
  styleUrls: ['./menu-items.css'],
  providers: [ExtraService, MenuItemService, CustomTitlePipe]
})
export class MenuItemsComponent implements OnInit {
  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
  pageTitle: string = 'Menu Items';
  eventId: string;
  menuItemList = new Array<MenuItems>();
  checkBoxies = [];
  message: string = null;

  menuClass = 'menulist-grp height220';

  constructor(
    private customTitlePipe: CustomTitlePipe, 
    private menuItemService: MenuItemService, 
    private extraService: ExtraService, 
    private route: ActivatedRoute, 
    private router: Router) {
    // console.log(MENU_ITEM_LIST);
  }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.refreshCheckBoxies();

    this.route.params.subscribe(params => {
      let id = params['eventId'];
      if (id) {
        this.setMenuList(id);
      }
    });
  }

  menuDivHeight() {
    if (this.menuClass == 'menulist-grp height220') {
      this.menuClass = 'menulist-grp height350';
    } else {
      this.menuClass = 'menulist-grp height220';
    }
  }

  toggleMenuItem(index: number) {

    let checkBox = this.checkBoxies[index];

    if (checkBox.checked) {
      let index = this.menuItemList.findIndex((obj) => { 
        return obj.realName == checkBox.value 
      });
      this.menuItemList = this.menuItemList.filter((val, i) => i != index);
      let i = 0;

      // Incremental Position
      this.menuItemList.forEach(element => {
        element.position = i + 1;
        i++;
      })
    } else {
      let menuItem = new MenuItems();
      menuItem.realName = checkBox.value;
      menuItem.customMenuItem = false;
      menuItem.isCustomMenuItem = false;
      menuItem.position = this.menuItemList.length + 1;
      this.menuItemList.push(menuItem);
      console.log(menuItem);
    }
  }

  upMenuItem(index) {
    if (index > 0) {
      let data = this.menuItemList[index - 1];
      this.menuItemList[index - 1] = this.menuItemList[index];
      this.menuItemList[index - 1].position = index;
      this.menuItemList[index] = data;
      this.menuItemList[index].position = index + 1;
    }
  }

  downMenuItem(index) {
    if (index < this.menuItemList.length) {
      let data = this.menuItemList[index + 1];
      this.menuItemList[index + 1] = this.menuItemList[index];
      this.menuItemList[index + 1].position = index + 2;
      this.menuItemList[index] = data;
      this.menuItemList[index].position = index + 1;
    }
  }

  setMenuList(id: string) {
    this.extraService.setCurrentEventId(id);
    this.eventId = id;
    this.menuItemService.getEventMenuItems(id).snapshotChanges().subscribe(list => {
      this.refreshCheckBoxies();
      this.menuItemList = new Array();
      //console.log(list);
      list.forEach(element => {
        let y = element.payload.toJSON() as MenuItems;
        //console.log(y);
        this.menuItemList.push(y);
        let index = this.checkBoxies.findIndex((obj) => { return obj.value == y.realName });
        this.checkBoxies[index].checked = true;
      });
    });
  }

  refreshCheckBoxies() {
    this.checkBoxies = new Array();
    MENU_ITEM_LIST.forEach(element => {
      this.checkBoxies.push(Object.assign({}, element));
    });
  }
  submit() {
    // console.log(this.menuItemList);
    this.menuItemList.forEach(menuItem => {
      if (menuItem.aliasName == null || menuItem.aliasName.trim().length < 1) {
        menuItem.aliasName = this.customTitlePipe.transform(menuItem.realName);
      }
    });
    this.menuItemService.addEventMenuItems(this.menuItemList, this.eventId).then(res => {
      this.message = 'Menu Items Updated Successfully';
    }).catch(error => {
      this.message = error.message;
    });
    setTimeout(function () {
      this.message = null;
    }.bind(this), 2000);
  }

  checkCharacter(index) {
    //if (this.menuItemList[index].aliasName.length > 14) {
    if (this.menuItemList[index].aliasName.length > 16) {
      this.menuItemList[index].aliasName = this.menuItemList[index].aliasName.substring(0,14);
    } 
  }
}






// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/menu-items/menu-items.ts